import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { Button, InputLabel, TextField } from '@mui/material';
import { createSymbolCategory, getImage, uploadFile } from '../../server/server';
import AddProductsImageModal from '../products/new-product/AddProductsImageModal';
import AddFileFromLibraryModal from '../media/AddFileFromLibraryModal';

function AddCategoryModal({ modalIsOpen, closeModal, category, reloadCategories }: any) {
	const [name, setName] = useState('');
	const [error, setError] = useState<any>({});
	const [addImageModalOpen, setAddImageModalOpen] = useState(false);
	const [libraryModalOpen, setLibraryModalOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const [image, setImage] = useState<any>();

	useEffect(() => {
		if (modalIsOpen) {
			ReactModal.setAppElement('#root');
		}
	}, [modalIsOpen]);

	useEffect(() => {
		if (!!category?.id) {
			setName(category.name);
			setImage(category.image);
		}
	}, [category]);

	const onSubmit = async () => {
		if (!checkIfIsValid()) return;
		const data: any = {
			name: name,
			imageId: image?.id ? image.id : null,
		};
		if (!category?.id) {
			createNewCategory(data);
			alert('Category is created!');
		} else {
			data.id = category.id;
			createNewCategory(data);
			alert('Category is updated!');
		}
	};

	const createNewCategory = async (data: any) => {
		const resp = await createSymbolCategory(data);
		if (resp.status === 201) {
			closeModalAndReloadOptions();
		}
	};

	const closeModalAndReloadOptions = () => {
		reloadCategories();
		closeModal();
	};

	const reset = () => {
		setName('');
	};

	const checkIfIsValid = () => {
		let valid = true;
		if (!name) {
			setError((e: any) => ({ ...e, name: 'Required filed ' }));
			valid = false;
		}

		return valid;
	};

	const closeAddImageModal = () => {
		setAddImageModalOpen(false);
	};

	const closeLibraryModal = () => {
		setLibraryModalOpen(false);
	};

	const handleSelectThumbnailImage = (id: any) => {
		setImage({ id: id });
	};

	const handleNameChange = (event: any) => {
		setError({ ...error, name: !!event.target.value ? '' : 'Required filed' });
		setName(event.target.value);
	};

	const handleNewImage = async (file: any) => {
		if (!!file) {
			setLoading(true);
			const resp = await uploadFile({ file: file, selectable: 'true' });
			if (resp.status == 201) {
				const uploadedImage = resp.data;
				setImage({ id: uploadedImage.id });
				setLoading(false);
				closeAddImageModal();
			} else {
				setLoading(false);
				return;
			}
		}
	};
	return (
		<ReactModal
			ariaHideApp={false}
			//closeTimeoutMS={600}
			isOpen={modalIsOpen}
			onAfterOpen={() => {}}
			onAfterClose={() => reset()}
			onRequestClose={closeModal}
			className="no-scroll"
			style={{
				overlay: {
					zIndex: 5,
					backdropFilter: 'brightness(30%)',
				},
				content: {
					padding: 0,
					opacity: 1,
					width: 600,
					margin: 'auto',
					backgroundColor: 'transparent',
					height: '100%',
					maxHeight: '100%',
					border: 'none',
					boxShadow: 'none',
					overflow: 'auto',
					paddingTop: 15,
					paddingBottom: 15,
				},
			}}
		>
			<div className="   max-h-[600px] w-full  ">
				<div className=" flex flex-1 flex-col gap-5 rounded-[10px] bg-white  px-[40px] py-[30px] ">
					<div className="flex w-full flex-col ">
						<p className="text-[30px] font-semibold leading-[38px] text-black textce">{!!category ? 'Edit symbol category' : 'Add new category'}</p>
					</div>
					<div className="col-span-2 ">
						<TextField required className=" background-transparent " value={name} onChange={(e) => handleNameChange(e)} helperText={error?.name ?? ''} error={!!error?.name} style={{ width: '100%' }} label="Group name" variant="filled" />
					</div>
					<div className="flex-1">
						<div className="flex w-full flex-col gap-5 justify-between">
							<InputLabel htmlFor="Category name">Thumbnail*</InputLabel>
							<div className="flex flex-row gap-5">
								<Button variant="contained" onClick={() => setLibraryModalOpen(true)} style={{ backgroundColor: '#2ec4b6', color: 'white' }}>
									Add image from library
								</Button>
								<Button variant="contained" onClick={() => setAddImageModalOpen(true)} style={{ backgroundColor: '#2ec4b6', color: 'white' }}>
									Add new image
								</Button>
							</div>
						</div>
						{/* <InputLabel htmlFor="category-image-input" error={!!error.thumbnailImage}>
							Thumbnail *
						</InputLabel> */}
						{/* <Input id="category-image-input" type="file" fullWidth onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleImageChange(e, setThumbnailImage, 'thumbnailImage')} inputProps={{ accept: 'image/png, image/jpg' }} error={!!error.thumbnailImage} /> */}
						{/* {!!error.thumbnailImage && <span className="error-labels-product-design">{error.thumbnailImage}</span>} */}
						<div className="flex space-x-2 mt-2">{!!image && <img key="thumbnail_image" src={getImage(image?.id)} alt="category-file" style={{ width: '200px', height: '200px', objectFit: 'contain' }} />}</div>
					</div>

					<div className="flex w-full flex-row justify-end gap-8 mt-10  ">
						<Button variant="contained" onClick={() => closeModal()} style={{ backgroundColor: '#2ec4b6', color: 'white' }}>
							Cancel
						</Button>
						<Button variant="contained" onClick={() => onSubmit()} style={{ backgroundColor: '#2ec4b6', color: 'white' }}>
							Submit
						</Button>
					</div>
				</div>
			</div>
			<AddProductsImageModal modalIsOpen={addImageModalOpen} closeModal={closeAddImageModal} setSelectedFileToList={handleNewImage} loading={loading} />
			<AddFileFromLibraryModal modalIsOpen={libraryModalOpen} closeModal={closeLibraryModal} returnSelectedFile={handleSelectThumbnailImage} />
		</ReactModal>
	);
}

export default AddCategoryModal;
